import React from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { AUTHENTICATED_ENTRY, PHOTOGRAPHER_AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import { protectedRoutes, publicRoutes, photographerRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';
import { useSelector } from 'react-redux';
import { ROLE_IDS } from 'constants/RolesConstats';

const Routes = () => {
	const { singleUser, token } = useSelector((state) => state.auth);

	const getAuthenticatedEntry = () => {
		switch (singleUser?.role?.position_id) {
			case ROLE_IDS.PHOTOGRAPHER:
				return PHOTOGRAPHER_AUTHENTICATED_ENTRY;
			default:
				return AUTHENTICATED_ENTRY;
		}
	};

	// Helper function to render routes with children
	const renderRouteWithChildren = (route, isProtected = true) => {
		const routeElement = (
			<AppRoute
				routeKey={route.key}
				component={route.component}
				{...route.meta}
			/>
		);

		if (route.children) {
			return (
				<Route
					key={route.key}
					path={route.path}
					element={routeElement}
				>
					{route.children.map((childRoute) => (
						<Route
							key={childRoute.key}
							path={childRoute.path}
							element={
								<AppRoute
									routeKey={childRoute.key}
									component={childRoute.component}
									{...childRoute.meta}
								/>
							}
						/>
					))}
				</Route>
			);
		}

		return (
			<Route
				key={route.key}
				path={route.path}
				element={routeElement}
			/>
		);
	};

	// Filter routes based on user role
	const getFilteredProtectedRoutes = () => {
		if (singleUser?.role?.position_id === ROLE_IDS.PHOTOGRAPHER) {
			return photographerRoutes;
		}
		return protectedRoutes;
	};

	return (
		<RouterRoutes>
			{/* Protected routes */}
			<Route path="/" element={<ProtectedRoute />}>
				<Route path="/" element={<Navigate replace to={getAuthenticatedEntry()} />} />
				{getFilteredProtectedRoutes().map((route) => renderRouteWithChildren(route))}
				<Route path="*" element={<Navigate to="/" replace />} />
			</Route>

			{/* Public routes */}
			<Route path="/" element={<PublicRoute />}>
				{publicRoutes.map((route) => renderRouteWithChildren(route, false))}
			</Route>
		</RouterRoutes>
	);
};

export default Routes;